// Load only when a report is previewed. The worker is bundled locally;
// no report data, fonts or images are sent to third-party services.
export async function loadPdfRenderer() {
  const pdf = await import('pdfjs-dist/legacy/build/pdf.mjs');
  if (!pdf.GlobalWorkerOptions.workerPort) {
    pdf.GlobalWorkerOptions.workerPort = new Worker(new URL('pdfjs-dist/legacy/build/pdf.worker.mjs', import.meta.url), { type: 'module' });
  }
  return pdf;
}
